<template>
  <div class="col-12">
    <div class="row">
      <div class="cpl-12 image-avatar-container" v-for="(i,index) in 3">
        <template v-if="getUserUsers[index]">
          <img :title="getUserUsers[index].name" class="rounded-pill image-avatar bg-white border p-1" width="43" height="43" :src="getUserUsers[index].image"
               :alt="getUserUsers[index].name"/>
        </template>
      </div>
      <span>...</span>
    </div>

  </div>
</template>

<script>
import {userAvatar} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/User";

export default {
  name: "UserInChat",
  props: {
    userInChat: {}
  },
  data() {
    return {
      data: [],
      userAvatar,
    }
  },
  methods: {
    getGroupUsers(group) {
      group.users.forEach(item => {
        this.data.push(
            {
              "name": item.name,
              "last_name": `${item.last_name} (${group.name})`,
              "image": item.image == null ? this.userAvatar : item.image
            }
        )
      })
    }
  },
  computed: {
    getUserUsers() {
      this.userInChat.forEach(item => {

        if (item.group == null) {
          this.data.push(
              {
                "name": item.user.name,
                "last_name": item.user.last_name,
                "image": item.user.image == null ? this.userAvatar : item.user.image
              }
          )
        } else {
          this.getGroupUsers(item.group)
        }
      })
      return this.data
    },
  },
}
</script>

<style scoped>
.image-avatar-container:nth-child(1) {
  z-index: 3;
}

.image-avatar-container:nth-child(2) {
  margin-right: -20px;
  z-index: 2;
}

.image-avatar-container:nth-child(3) {
  margin-right: -20px;
  z-index: 1;
}
</style>